/* eslint-disable no-dupe-keys */
import CONFIG from '@/config/index';
import { alert, hideLoading } from '@/utils/prompt';
import jump from '@/utils/jump';
import eventReporter from '@/utils/event-reporter';
import store from '@/vuex/index';
import { loginWhiteList } from '@/constants';
import { isObject } from '@/utils';
const getUrl = url => {
  if (url.indexOf('://') === -1) {
    url = process.env.VUE_APP_BASE_URL + url;
  }
  return url;
};

const http = ({ url = '', data = {}, ...other } = {}) => {
  const { token } = store.state;
  const option = { ...other };
  const defaultHeader = {
    'X-Tenant-Id': CONFIG.TENANT_ID,
    'X-Ext-Tenant-Id': CONFIG.EXT_TENANT_ID,
    'X-Client-Type': CONFIG.CLIENT_TYPE,
    'X-MiniApps-Id': CONFIG.APPID,
  };

  const extJson = {};
  const sensorsDistinctId = eventReporter.getSensorsDistinctId();
  if (sensorsDistinctId) {
    defaultHeader['X-Sensa-Anon-Id'] = sensorsDistinctId;
    extJson.sensaAnonId = sensorsDistinctId;
  }
  //* 处理推广员参数
  const promoter = store.state.promoter;
  const promoterExpireTime = store.state.promoterExpireTime || 0;
  if (promoter && promoterExpireTime > Date.now()) {
    extJson.promoterId = promoter;
  }
  /* 如果是支付宝小程序模板提审
   * 登录时不显示支付宝授权登录
   * templateApiList里的接口需要改X-Client-Type: TEMPLATE_TINYAPP
   */
  const templateApiList = [
    '/shopmember/api/token/alipay/loginByVerifyCode',
    '/shopmember/api/alipay/memberAuth/loginByVerifyCode',
    '/shopmember/api/alipay/memberAuth/loginByCode',
    '/shopmember/api/alipay/memberAuth/bindingMobile',
  ];
  const clientType = CONFIG.CLIENT_TYPE;
  const isTemplatePublish = CONFIG.extConfig && CONFIG.extConfig.isTemplatePublish;
  const changeClientType = templateApiList.some(item => {
    const idx = url.indexOf(item);
    return idx > -1;
  });
  if (clientType === 'tinyapp' && isTemplatePublish && changeClientType) {
    defaultHeader['X-Client-Type'] = 'template_tinyapp';
  }
  // 灰度发布 所有接口请求都带上region:gray,非灰度模式，则不需要此header值
  if (CONFIG.ENV === 'gray' || CONFIG.ENV === 'uat') {
    defaultHeader.region = 'gray';
  }
  if (token) {
    defaultHeader['X-User-Token'] = token;
  }


  let adInfo = uni.getStorageSync('adInfo');
  if (adInfo) {
    try {
      adInfo = JSON.parse(adInfo);
      if (adInfo.content && adInfo.expireTime && adInfo.expireTime > Date.now()) {
        defaultHeader['X-Ad-Info'] = adInfo.content;
      } else {
        throw new Error('adInfo异常!');
      }
    } catch (e) {
      uni.removeStorageSync('adInfo');
    }
  }

















  const { openId } = store.state;
  if (openId) {
    defaultHeader.open_id = openId;
    defaultHeader.openid = openId;
    defaultHeader['X-Anon-Id'] = openId;
  }


  const reporterInfo = store.state.reporterInfo;
  const { anonId } = reporterInfo;
  if (anonId) {
    defaultHeader['X-Anon-Id'] = anonId;
  }


  // 有疑问 上报暂时注释
  const utm = store.state.utm;
  if (utm) {
    const generateUtmKey = utmKey => {
      const keys = utmKey.split('_').map(v => v[0].toUpperCase() + v.slice(1));
      return keys.join('-');
    };
    const camelCaseKey = key => {
      if (!key) return '';
      let _key = '';
      const index = key.indexOf('_');
      if (index > 0 && index < key.length - 1) {
        _key = key
          .split('_')
          .map((v, i) => {
            if (i > 0) {
              return v[0].toUpperCase() + v.slice(1);
            }
            return v;
          })
          .join('');
      }
      return _key;
    };
    for (const key in utm) {
      defaultHeader[`X-${generateUtmKey(key)}`] = encodeURIComponent(utm[key]);
      extJson[`${camelCaseKey(key)}`] = encodeURIComponent(utm[key]);
    }
  }
  if (extJson && JSON.stringify(extJson) !== '{}') {
    let str = '';
    isObject(extJson) &&
      Object.keys(extJson).forEach((v, i) => {
        if (i > 0) str += '&';
        str += `${v}=${extJson[v]}`;
      });
    if (str) defaultHeader['X-Ext-Json'] = str;
  }
  const header = Object.assign(defaultHeader, option.header || {});
  delete option.header;
  // 小程序还是加上接口请求日志吧，不然不方便查看问题



  return new Promise((resolve, reject) => {
    const timeStart = Date.now();
    uni.request({
      timeout: 20 * 1000,
      url: getUrl(url),
      data,
      header,
      ...option,
      complete: res => {
        if (res.statusCode === 200) {



          if (res.data.code !== '0') {
            if (res.data.code === '601') {
              const pages = getCurrentPages();
              if (pages.length > 0) {
                const page = pages[pages.length - 1];
                // eslint-disable-next-line no-proto
                const routeName = page.__proto__.route;
                if (routeName === 'pages/busy') {
                  return;
                }
              }
              jump.to('/pages/activity/busy');
              return;
            }
            if (res.data.code === '800') {
              alert('业务系统繁忙,请您稍后再试');
              const mStr = `接口调用800, option:${JSON.stringify(
                option
              )}, response: ${JSON.stringify(res)}`;
            } else if (res.data.code === '400') {
              // 两种情况，一种是用户从来没登录的，一种是登录过的
              if (__isLoggedInBefore() && notInWhiteList()) {
                // 用户本地 token 失效，需要重新登录 !!!
                __logout(); // 清除本地登录信息
                hideLoading();
                jump.toPage('5');
              }
            }
          }
          resolve(res.data);
        } else {
          if (
            url === '/tracker-service/event/batchReport' ||
            url === '/tracker-service/event/report' ||
            url === '/shopmember/api/creditRule/getShoppingCreditRule'
          ) {
            return;
          }
          const errorString = JSON.stringify(res);
          alert('您的网络开小差了，请您稍后再试~');
          hideLoading();

          const mStr = `请求响应失败：option:${JSON.stringify(option)}, response: ${JSON.stringify(
            res
          )}`;
          reject(new Error(errorString));
        }
      },
    });
  });
};

const notInWhiteList = function() {
  // 登录白名单页面不跳转登录
  const pages = getCurrentPages();
  const page = pages[pages.length - 1];
  const route = page ? page.route : '';
  if (loginWhiteList.includes(route)) return false;
  return true;
};

const __isLoggedInBefore = function() {
  const { token } = store.state;
  // 如果给出了第三个参数且非null/undefined/0/""/等值，则inv为true，否则为false
  return !!token;
};

const __logout = function() {
  store.dispatch('logout');
};

/**
 * 发送get请求
 * @param {String} url 请求的url
 * @param {Object} data 请求的入参数据
 * @param {Object} option  额外设置项，参考uni.request的配置项
 */
const get = (url, data = {}, option = {}) => {
  return http({
    url,
    data,
    ...option,
  });
};

/**
 * 发送POST请求
 * @param {String} url 请求的url
 * @param {Object} data 请求的入参数据
 * @param {Object} option 额外的设置项，参考uni.request的配置项
 */
const post = (url, data = {}, option = {}) => {
  return http({
    url,
    data,
    method: 'post',
    ...option,
  });
};

/**
 * 发送POST请求
 * @param {String} url 请求的url
 * @param {Object} data 请求的入参数据
 * @param {Object} option 额外的设置项，参考uni.request的配置项
 */
const upload = (url, data = {}, option = {}) => {
  return httpUpload({
    url,
    data,
    method: 'post',
    ...option,
  });
};

export default {
  get,
  post,
  upload,
};

const httpUpload = ({ url = '', data = {}, ...other } = {}) => {
  const { openId, token } = store.state;
  const timeStart = Date.now();
  const option = { ...other };
  const defaultHeader = {
    'X-Tenant-Id': CONFIG.TENANT_ID,
    'X-Ext-Tenant-Id': CONFIG.EXT_TENANT_ID,
    // 'content-type': 'multipart/form-data;charset=utf-8',
    Accept: 'application/json',
    'X-Client-Type': CONFIG.CLIENT_TYPE,
    'X-MiniApps-Id': CONFIG.APPID,
  };
  // 灰度发布 所有接口请求都带上region:gray,非灰度模式，则不需要此header值
  if (CONFIG.ENV === 'gray') {
    defaultHeader.region = 'gray';
  }
  if (token) {
    defaultHeader['X-User-Token'] = token;
  }
  if (openId) {
    defaultHeader.open_id = openId;
    defaultHeader.openid = openId;
  }
  const header = Object.assign(defaultHeader, option.header || {});
  delete option.header;
  const filePath = data.filePath;
  const file = data.file;
  return new Promise(resolve => {
    uni.uploadFile({
      url: getUrl(url),



      files: [
        {
          name: 'file',
          file,
          uri: filePath,
        },
      ],
      header: {
        ...header,
        //! H5不能设置 "Content-Type": "multipart/form-data",




      },





      complete: res => {
        if (res.statusCode === 200) {
          resolve(res.data);
        } else {
          alert('系统繁忙,请您稍后再试');
        }
      },
    });
  });
};
